<template>
    <div class="home">
        <div class="mdui-spinner mdui-spinner-colorful loading"></div>
    </div>
</template>

<script>
export default {
  name: 'index',
  mounted () {
    this.mdui.mutation()
    this.$router.replace({ path: '/exchange', query: this.$route.query })
  },
  methods: {}
}
</script>

<style scoped>
    .loading {
        margin-top: 20%;
    }

</style>
